import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { Input } from "sr/helpers";

type Props = {
  data: { documents_required?: { doc_name: string }[] };
  HandleDataProps: (payload: { documents_required: { doc_name: string }[] }) => void;
  externalErrorId?: string;
};

const RequirementDocumentsChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const [docsInput, setDocsInput] = useState("");

  useEffect(() => {
    if (data?.documents_required?.length) {
      setDocsInput(data.documents_required.map((d) => d.doc_name).join(", "));
    }
  }, [data?.documents_required]);

  useEffect(() => {
    HandleDataProps({
      documents_required: docsInput
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .map((s) => ({ doc_name: s })),
    });
  }, [docsInput]);

  useImperativeHandle(ref, () => ({
    validateData: () => true, // optional
    submitForm: () => ({
      documents_required: docsInput
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .map((s) => ({ doc_name: s })),
    }),
  }));

  return (
    <div>
      <p className="pt-4 text-base">Documents Required</p>
      <Input
        name="documents_required"
        value={docsInput}
        onChange={(e: any) => setDocsInput(e.target.value)}
        placeholder="Enter required documents separated by commas"
        error={externalErrorId}
      />
    </div>
  );
});

export default RequirementDocumentsChange;
